import { Vue, Component } from 'vue-property-decorator';

@Component({})
export default class ContentLoaderMixin extends Vue {
    public primaryColor: string = 'hsla(var(--before-load-darken), 0.8)';
    public secondaryColor: string = 'hsl(var(--before-load))';
    public animate: boolean = true;
    public speed: number = 2;
}
